import { TagsList } from '../../features/tags/component/TagsList';

export default function TagsPage() {
  return <TagsList />;
}
